import Swal from "sweetalert2"

export const SECTIONS = {
    login: "login",
    auth: "auth",
    report: "report"
}

export const RESULTS_SECTIONS = {
    edit: "edit",
    map: "map",
    wants: "wants"
}

export const ACTIONS = {
    setActiveSection: "SET_ACTIVE_SECTION",
    setTeaserCities: "SET_TEASER_CITIES",
    setResultsSection: "SET_RESULTS_SECTION",
    setSubscribeAlertShow: "SET_SUBSCRIBE_ALERT_SHOW",
    setTriggerVariableDetails: "SET_SHOW_VARIABLE_DETAILS",
    setWantsMatrixReference: "SET_WANTS_MATRIX_REFERENCE",
    setClientAndSupplierLocation: "SET_CLIENT_LOCATION",
    setShowColumn: "SET_SHOW_COLUMN"
}

export const APP_ROUTES = {
    login: "/login",
    auth: "/login/authUser",
    report: "/report",
    results: "/results"
}

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export function sweetAlertLoading() {
    Swal.fire({
        footer: 'Loading, please wait',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
            Swal.showLoading()
        },
    })
}

export const monterreyMetroplex = 1
export const torreon = 5035
export const queretaroMetroplex = 2
export const sanLuisPotosiMetroplex = 4
export const ciudadJuarez = 8037
export const hermosillo = 26030
export const tijuana = 2004
export const guadalajaraMetroplex = 8
export const saltillo = 5030
export const leon = 11020